import styled from 'styled-components'
import {
  lineHeight,
  fontSize,
  color,
  textStyle,
  fontWeight,
  textAlign,
} from 'styled-system'

const StyledDynamicComponent = styled.p`
  ${lineHeight}
  ${fontSize}
  ${color}
  ${textStyle}
  ${fontWeight}
  ${textAlign}
`

export default StyledDynamicComponent
